<template>
  <div>
    <usernav></usernav>
    <el-col class="LeftPart">
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          用户推广
        </div>
        <div class="m2">推广总人数：{{count}}</div>
        <div class="m2">
          推广链接：【
          <span style="color: #f39;cursor:pointer" v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="onError">{{link}}</span>】
        </div>
        <div class="m2">
          <el-button size="mini" round v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制推广链接</el-button>
        </div>
        <div class="p4">
          * 使用上方推广链接注册新用户即可获得以下对应奖励：
        </div>
        <div class="p4">
            1）凡推广注册一个有效用户即可获得2积分奖励。
        </div>
        <div class="p4">
            2）推广达到兑换VIP指定人数即可兑换VIP，推广人数叠加计算。
        </div>
        <div class="p4">
          * 一个IP只算一次有效注册。
        </div>
      </el-card>
    </el-col>
    <el-col class="RightPart">
      <el-card shadow="never" style="text-align: left">
        <div class="text-dark">
          推广人数兑换会员
        </div>
        <div v-for="item of tableData" :key="item.promote" class="m2">
          累计推广{{item.promote}}人可兑换【{{item.title}}】
        </div>
        <div v-for="item of tableData" :key="item.promote" class="m2">
          <el-popconfirm title="确定要兑换会员吗？"  @confirm="buy_promote(item.id)">
            <el-button style="width: 200px" slot="reference" :disabled="item.type" plain size="small">
              <span v-show="item.type">已兑换{{item.title}}</span>
              <span v-show="!item.type">【{{count}}/{{item.promote}}】兑换{{item.title}}</span>
            </el-button>
          </el-popconfirm>
        </div>
      </el-card>
    </el-col>
  </div>
</template>

<script>
import Usernav from '@/components/base/header/usernav'
import {request} from '../../network/request'
export default {
  components: {Usernav},
  name: 'promote',
  data () {
    return {
      tableData: [],
      link: '',
      count: 0
    }
  },
  created () {
    this.get_promote()
  },
  methods: {
    buy_promote (id) {
      let data = new URLSearchParams()
      data.append('type', '2')
      data.append('id', id)
      request({
        url: '/api/upgrade',
        method: 'post',
        data: data
      }).then(function (res) {
        if (res.data.status === 0) {
          this.$message.success('兑换成功')
          this.get_promote()
        } else {
          this.$message.error('兑换失败')
        }
      }.bind(this)).catch(err => {
        console.log(err)
      })
    },
    get_promote () {
      request({
        url: '/api/promote',
        method: 'post'
      }).then(res => {
        if (res) {
          this.tableData = res.data.commodity
          this.link = res.data.link
          this.count = res.data.count
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onCopy () {
      this.$message.success('复制成功')
    },
    onError () {
      this.$message.console.error('复制失败')
    }
  }
}
</script>

<style scoped>
  .G-title {
    border-bottom: 1px solid #f2f2f2 !important;
    padding-bottom: 10px;
  }

  .p4 {
    font-size: 14px;
    padding-top: 5px;
    color: #ff3399;
  }

  .p3 {
    padding-top: .5rem !important;
  }

  .p2 {
    font-size: 14px;
  }

  .text-dark {
    color: #333 !important;
    font-weight: 700 !important;
    margin-top: .5rem !important;
    margin-bottom: .5rem !important;
    font-size: 14px;
  }

  .m2 {
    margin-bottom: .5rem;
    margin-top: .5rem;
    font-size: 14px
  }
  .Profile{
    padding-left: 10px;
    margin-top: 15px !important;
    margin-bottom: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/promote.vue